import React, { Fragment, useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import { Grid, Box } from "@material-ui/core/";
import Dialog from "@material-ui/core/Dialog";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { getModel, delModel } from "../../services/service.api";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import "../../App.css";
import Alert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import FarmaceutaForm from "./PharmacyForm";
import Button from "@material-ui/core/Button";
import ConfirmDialog from "../commons/ConfirmDialog/ConfirmDialog";

export default function ListFarmaceutas(props) {
  const { user } = props;
  const [handleModal, setHandleModal] = useState({ open: false });
  const [pharmacys, setPharmacys] = useState([]);
  const [showAlert, setShowAlert] = useState({ open: false });
  const [confirmOpen, setconfirmOpen] = useState({});

  const getFarmaceutas = async () => {
    try {
      const { data } = await getModel("users/people", {
        params: { pharmacy_id: user.pharmacy_id, role_id: 4 }
      });
      if (data) {
        setPharmacys(data);
      } else {
        setPharmacys([]);
      }
    } catch (error) {
      console.log(error);
      setShowAlert({
        open: true,
        message: error.message,
        type: "error"
      });
    }
  };
  const ConfirmDelete = async itemId => {
    try {
      await delModel("users")(itemId);
      setShowAlert({
        open: true,
        message: "Farmacéutico borrado Satisfactoriamente!",
        type: "success"
      });
    } catch (error) {
      console.log(error);
      setShowAlert({
        open: true,
        message: error.message,
        type: "error"
      });
    }
  };
  useEffect(
    () => {
      getFarmaceutas();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [showAlert, handleModal]
  );

  return (
    <Fragment>
      <Box boxShadow={5}>
        <Box p={1} m={4}>
          <Grid>
            <Box display="flex" p={4}>
              <Box p={1} flexGrow={1}>
                <h1>Farmacéuticos</h1>
              </Box>
              <Box mr={2}>
                <TextField id="busqueda" label="Buscar" />
              </Box>
              <Box p={1}>
                <Button
                  style={{ borderRadius: 10 }}
                  color="primary"
                  variant="contained"
                  onClick={() => setHandleModal({ open: true })}
                >
                  Crear farmacéutico
                </Button>
              </Box>
            </Box>
          </Grid>
          <Grid container spacing={4}>
            <Dialog
              onClose={() => setHandleModal({})}
              aria-labelledby="customized-dialog-title"
              open={handleModal.open}
            >
              <FarmaceutaForm
                {...{
                  pharmacy: handleModal.pharmacy,
                  setHandleModal,
                  setShowAlert,
                  user
                }}
              />
            </Dialog>
          </Grid>
          <Grid>
            <Table>
              <Thead>
                <Tr align="right">
                  <Th>Nombre</Th>
                  <Th>Dirección</Th>
                  <Th>Telefono</Th>
                  <Th align="center">OPCIONES</Th>
                </Tr>
              </Thead>
              <Tbody>
                {pharmacys.map((pharmacy, key) => (
                  <Tr align="right" key={key}>
                    <Td>{pharmacy.profile.rut}</Td>
                    <Td>
                      {pharmacy.profile.first_name} {pharmacy.profile.last_name}
                    </Td>

                    <Td>{pharmacy.profile.phone}</Td>
                    <Td>{pharmacy.farmacia.local_name}</Td>
                    <Td align="center">
                      <EditIcon
                        color="primary"
                        onClick={() => setHandleModal({ open: true, pharmacy })}
                      />
                      <DeleteIcon
                        color="primary"
                        onClick={() => {
                          setconfirmOpen({
                            ...confirmOpen,
                            [`${pharmacy.id}`]: true
                          });
                        }}
                      />

                      <ConfirmDialog
                        title={
                          pharmacy.profile.first_name +
                          " " +
                          pharmacy.profile.last_name
                        }
                        open={pharmacy ? confirmOpen[pharmacy.id] : false}
                        row={pharmacy}
                        setconfirmOpen={setconfirmOpen}
                        ConfirmDelete={ConfirmDelete}
                      >
                        ¿Estás seguro de Eliminar al Manager
                        {pharmacy.profile.first_name +
                          " " +
                          pharmacy.profile.last_name}{" "}
                        ?
                      </ConfirmDialog>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Grid>
        </Box>
      </Box>
      <Snackbar
        open={showAlert.open}
        autoHideDuration={6000}
        onClose={() => setShowAlert({})}
      >
        <Alert onClose={() => setShowAlert({})} severity={showAlert.type}>
          {showAlert.message}
        </Alert>
      </Snackbar>
    </Fragment>
  );
}
